import { HorseIcon } from './HorseIcon';

/**
 * author: Colton Wiscombe
 * id EA8A87CE-C2FE-4C05-8CD0-32C9716737D4
 * name horse
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/horse.svg
 * tags
 * - Transportation + Other 
 * - Animal 
 * - Agriculture 
 */
export const EquestrianIcon = HorseIcon;
export default EquestrianIcon